// Key/value storage. Web: localStorage. Capacitor: swap for @capacitor/preferences (same async API).
export const storage = {
  async get(key: string): Promise<string | null> {
    try { return window.localStorage.getItem(key); } catch { return null; }
  },
  async set(key: string, value: string): Promise<void> {
    try { window.localStorage.setItem(key, value); } catch { /* storage unavailable */ }
  },
  async remove(key: string): Promise<void> {
    try { window.localStorage.removeItem(key); } catch { /* storage unavailable */ }
  },
};
